/* Native POST remains the purchase fallback; no cart API or pixel duplication. */
(() => {
  if (customElements.get('ma-ritual-product')) return;
  class RitualProduct extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.querySelector('[data-ma-form]');
      this.select = this.querySelector('[name="id"]');
      this.mainImage = this.querySelector('[data-ma-main-image]');
      this.mainButton = this.querySelector('[data-ma-add]');
      this.stickyButton = this.querySelector('[data-ma-sticky-add]');
      this.stickyBar = this.querySelector('[data-ma-sticky]');
      this.select?.addEventListener('change', () => this.updateVariant(true));
      this.querySelectorAll('[data-ma-thumb]').forEach(button => {
        button.addEventListener('click', () => this.showImage(button));
      });
      this.stickyButton?.addEventListener('click', () => {
        if (this.form && this.mainButton && !this.mainButton.disabled) this.form.requestSubmit(this.mainButton);
      });
      this.form?.addEventListener('submit', event => {
        if (this.mainButton.disabled) { event.preventDefault(); return; }
        // A normal Shopify form submission handles stock limits, validation and cart navigation.
        if (this.stickyButton) this.stickyButton.disabled = true;
      });
      this.updateVariant(false);
      if (this.mainButton && this.stickyBar && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.stickyBar.hidden = entries[0].isIntersecting;
        }, { threshold: 0 });
        this.observer.observe(this.mainButton);
      }
    }
    disconnectedCallback() { this.observer?.disconnect(); this.initialized = false; }
    showImage(button) {
      if (!this.mainImage || !button) return;
      this.mainImage.src = button.dataset.src;
      this.mainImage.srcset = button.dataset.srcset || '';
      this.mainImage.alt = button.dataset.alt || '';
      this.querySelectorAll('[data-ma-thumb]').forEach(thumb => thumb.setAttribute('aria-pressed', String(thumb === button)));
    }
    updateVariant(updateURL) {
      const option = this.select?.selectedOptions[0];
      if (!option) return;
      this.querySelectorAll('[data-ma-price]').forEach(node => node.textContent = option.dataset.price);
      this.querySelectorAll('[data-ma-compare]').forEach(node => {
        node.textContent = option.dataset.compare || '';
        node.hidden = !option.dataset.compare;
      });
      const available = option.dataset.available === 'true' && this.dataset.requiresPlan !== 'true';
      const label = available ? 'Add to cart' : this.dataset.requiresPlan === 'true' ? 'Purchase option unavailable' : 'Sold out';
      for (const button of [this.mainButton, this.stickyButton]) {
        if (button) { button.disabled = !available; button.textContent = label; }
      }
      const thumb = [...this.querySelectorAll('[data-ma-thumb]')].find(node => node.dataset.imageId === option.dataset.imageId);
      if (thumb) this.showImage(thumb);
      if (updateURL) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState({}, '', url);
      }
    }
  }
  customElements.define('ma-ritual-product', RitualProduct);
})();
